import React, { useContext } from 'react';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { AuthContext, AuthContextProps } from 'shared/providers/auth';
import { buildNumber, displayVersion } from 'shared/utils/appVersionUtils';

import PageDownErrorMessage, {
  PageDownErrorMessageProps,
} from './PageDownErrorMessage';

export interface TabDownErrorMessageProps
  extends Omit<
    PageDownErrorMessageProps,
    | 'primaryButtonText'
    | 'primaryOnPress'
    | 'secondaryButtonText'
    | 'secondaryOnPress'
    | 'footerText'
  > {
  tryAgainAction: (...args) => unknown;
}

const TabDownErrorMessage = (props: TabDownErrorMessageProps) => {
  const { tryAgainAction } = props;
  const { handleLogout } = useContext<AuthContextProps>(AuthContext);
  const { pageDownTitle, pageDownMessage } = useDefaultErrorStrings();

  return (
    <PageDownErrorMessage
      illustrationKey="HOURGLASS_A"
      {...props}
      title={pageDownTitle}
      message={pageDownMessage}
      primaryButtonText="Try again"
      primaryOnPress={tryAgainAction}
      secondaryButtonText="Log out"
      secondaryOnPress={handleLogout}
      footerText={`App version ${displayVersion} ${buildNumber ? `(${buildNumber})` : ''}`}
    />
  );
};

export default TabDownErrorMessage;
